import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useNotificationSettingsPageStore } from 'store/pages/user-settings/notification-settings/pageStore';
import { CheckCircle } from '@insurancemenu/imenu-components-lib/dist/icons';
import { colors } from '@insurancemenu/imenu-components-lib';
import NotificationEmailCard from './NotificationEmailCard';
import { EmailsListStyled, InfoTitleStyled, TotalAmountStyled } from './styles';

const NotificationSettings: React.FC = observer(() => {
  const { emails, emailsForUser } = useNotificationSettingsPageStore();

  const convertedEmails = emails.map((email) => toJS(email)).slice();
  const convertedEmailsForUser = emailsForUser.map((type) => toJS(type)).slice();

  return (
    <>
      <InfoTitleStyled>
        <CheckCircle width="24px" height="24px" color={colors.green[600]} />
        <TotalAmountStyled>
          {convertedEmailsForUser.length} of {convertedEmails.length}
        </TotalAmountStyled>
        email notifications enabled
      </InfoTitleStyled>
      <EmailsListStyled>
        {convertedEmails.map((email) => (
          <NotificationEmailCard
            key={email.name}
            email={email}
            isChecked={convertedEmailsForUser.includes(email.name)}
          />
        ))}
      </EmailsListStyled>
    </>
  );
});

export default NotificationSettings;
